/**
 * 로딩바 관리 service
 * @module shared/utils/LoadingBarService
 * @author Lian
 */

/**
 * 로딩바 type
 * @author Lian
 */
type LoadingControl = {
  /**
   * 로딩바 show 함수
   */
  show: () => void;
  /**
   * 로딩바 hide 함수
   */
  hide: () => void;
};

/**
 * 로딩바 관리용 map
 * @author Lian
 */
const controllers = new Map<string, LoadingControl>();

/**
 * 로딩바 등록
 * @author Lian
 */
export const registerController = (id: string, controller: LoadingControl): void => {
  controllers.set(id, controller);
};

/**
 * 로딩바 삭제
 * @author Lian
 */
export const unregisterController = (id: string): void => {
  controllers.delete(id);
};

/**
 * 해당 로딩바 검색
 * @author Lian
 */
export const getLoadingBar = (id: string): LoadingControl | undefined => controllers.get(id);
